
<div class="shopping-cart-modal">
  <div class="modal-header" id="sendCartHeader">
    <!-- <h6 class="pop-up-title">{{title}}</h6> -->
  </div>
  <div class="modal-body" id="sendCartBody">
    <div id="upload-sku">
      <div class="">
        <div class="upload-content">
          <div class="enter-code">
            <textarea class="pop-up-grey-text" placeholder="Please enter a reason for sending this cart:" onfocus="this.placeholder=''" onblur="this.placeholder='Please enter a reason for sending this cart:'" id="reasonText" rows="3" cols="50" [(ngModel)]="reasonText"></textarea>
          </div>
          <div id="contact-email">
            <div class="label">Contact email:</div>
            <input id="emailText" class="pop-up-black-text" [(ngModel)]="emailText"/>
          </div>
          <div id="divSending">
            <button id="send-cart" *ngIf="sendingFinished" class="button button-large button-red" (click)="sendToSales()">Send</button>
            <button *ngIf="!sendingFinished" class="button button-large button-red" style="width: 100%;" disabled>
              Sending...
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

